import * as React from 'react';
import {
  Heading, Button, Row, Col,
} from '@elevationscu/ui-component-lib';
import styles from './user-credit.module.scss';
import InputRequest from './input-request';
import ProgressBar from './ProgressBar';
import DataDisclaimer from './data-disclaimer';

export default function UserCredit({
  pageNumber, userInfo, setUserInfo, nextPage, previousPage, maxPages,
}) {
  const creditScores = ['780+', '760-779', '740-759', '720-739', '700-719', '680-699', '660-679', '620-659', 'Below 620', "I'm not sure"];
  const [chosenScore, setChosenScore] = React.useState();
  const [validated, setValidated] = React.useState(false);

  React.useEffect(() => {
    if (userInfo.application_data.user_credit) {
      setChosenScore(userInfo.application_data.user_credit);
      setValidated(true);
    }
  }, [userInfo.application_data]);

  function selectedCredit(score) {
    setChosenScore(score);
    setValidated(true);
    userInfo.application_data = Object.assign(userInfo.application_data, {
      user_credit: score,
    });
  }

  function next() {
    userInfo.application_data = Object.assign(userInfo.application_data, {
      user_credit: chosenScore,
    });
    setUserInfo(userInfo);
    nextPage(userInfo);
  }

  function previous() {
    userInfo.application_data = Object.assign(userInfo.application_data, {
      user_credit: chosenScore,
    });
    setUserInfo(userInfo);
    previousPage(userInfo);
  }

  return (
    <div className={styles.mainContainer}>
      <div className={styles.coreData}>
        <div className={styles.coreHeader}>
          <Heading element="h1" size={2} className={styles.h1Heading}>
            How's your credit?
          </Heading>
          <InputRequest />
        </div>
        <div className={styles.prospectInput}>
          <ProgressBar
            pageNumber={pageNumber}
            maxPages={maxPages}
          />
          <Heading element="h2" size={3} className={styles.h2Heading}>
            What is your estimated credit rating? (required)
          </Heading>
          <div role="radiogroup" aria-required="true" className={styles.radioButtons}>
            {creditScores.map((score) => (
              <Button
                id={`credit-btn-${score}`}
                onClick={() => selectedCredit(score)}
                variant="secondary"
                className={chosenScore !== score ? styles.creditButton : styles.selectedCreditButton}
                aria-label={score}
                required="required"
                role="radio"
                aria-checked={validated && score === chosenScore}
              >
                {score}
              </Button>
            ))}
          </div>
          <Row className={styles.rowSpacing}>
            <Col lg={8}>
              <DataDisclaimer />
            </Col>
            <Col className={styles.colSpacing}>
              <button onClick={previous} className={styles.previousButton} id="creditPreviousButton" type="button">
                Previous
              </button>
              <Button onClick={next} disabled={!validated} className={styles.nextButton} id="creditNextButton">
                Next
              </Button>
            </Col>
          </Row>

        </div>
      </div>
    </div>
  );
}
